import axios from 'axios';
import { Table, TableInfo } from '../../shared/ts/Table';
import { AppDispatch } from '../../store';

const appJsonConfig = {
	headers: {
		'Content-Type': 'application/json',
	},
};

export type TABLES_GET_REQUEST = {
	type: 'TABLES_GET_REQUEST';
};

export type TABLES_GET_SUCCESS = {
	type: 'TABLES_GET_SUCCESS';
	payload: Table[];
	pagination: { totalPages: number };
};

export type TABLES_GET_FAIL = {
	type: 'TABLES_GET_FAIL';
	payload: string;
};

export const getTables =
	(
		weddingId: number,
		number: number | string = '',
		name: string = '',
		relation: string = '',
		guestName: string = '',
		phone: string = '',
		pageNumber: number = 1
	) =>
	async (dispatch: AppDispatch) => {
		try {
			dispatch({ type: 'TABLES_GET_REQUEST' });

			if (phone) {
				phone = String(phone).replace(/^0+/, '');
			}

			const { data } = await axios.get(
				`/weddings/${weddingId}/tables?limit=25&page=${pageNumber}&number=${number}&name=${name}&relation=${relation}&guestName=${guestName}&phone=${phone}`
			);

			dispatch({
				type: 'TABLES_GET_SUCCESS',
				payload: data.data,
				pagination: { totalPages: data.totalPages },
			});
		} catch (error: any) {
			dispatch({
				type: 'TABLES_GET_FAIL',
				payload: error.response.data.message,
			});
		}
	};

export type TABLE_POST_REQUEST = {
	type: 'TABLE_POST_REQUEST';
};

export type TABLE_POST_SUCCESS = {
	type: 'TABLE_POST_SUCCESS';
};

export type TABLE_POST_FAIL = {
	type: 'TABLE_POST_FAIL';
	payload: string;
};

export type TABLE_POST_RESET = {
	type: 'TABLE_POST_RESET';
};

export const postTable =
	(weddingId: number, tableInfo: TableInfo) =>
	async (dispatch: AppDispatch) => {
		try {
			dispatch({ type: 'TABLE_POST_REQUEST' });
			await axios.post(
				`/weddings/${weddingId}/tables`,
				tableInfo,
				appJsonConfig
			);

			dispatch({ type: 'TABLE_POST_SUCCESS' });
		} catch (error: any) {
			dispatch({
				type: 'TABLE_POST_FAIL',
				payload: error.response.data.message,
			});
		}
	};

export type TABLE_EDIT_REQUEST = {
	type: 'TABLE_EDIT_REQUEST';
};

export type TABLE_EDIT_SUCCESS = {
	type: 'TABLE_EDIT_SUCCESS';
};

export type TABLE_EDIT_FAIL = {
	type: 'TABLE_EDIT_FAIL';
	payload: string;
};

export type TABLE_EDIT_RESET = {
	type: 'TABLE_EDIT_RESET';
};

export const editTable =
	(weddingId: number, tableId: number, editInfo: TableInfo) =>
	async (dispatch: AppDispatch) => {
		try {
			dispatch({ type: 'TABLE_EDIT_REQUEST' });
			await axios.patch(
				`/weddings/${weddingId}/tables/${tableId}`,
				editInfo,
				appJsonConfig
			);

			dispatch({ type: 'TABLE_EDIT_SUCCESS' });
		} catch (error: any) {
			dispatch({
				type: 'TABLE_EDIT_FAIL',
				payload: error.response.data.message,
			});
		}
	};

export type TABLE_DELETE_REQUEST = {
	type: 'TABLE_DELETE_REQUEST';
};

export type TABLE_DELETE_SUCCESS = {
	type: 'TABLE_DELETE_SUCCESS';
};

export type TABLE_DELETE_FAIL = {
	type: 'TABLE_DELETE_FAIL';
	payload: string;
};

export type TABLE_DELETE_RESET = {
	type: 'TABLE_DELETE_RESET';
};

export const deleteTable =
	(weddingId: number, tableId: number) => async (dispatch: AppDispatch) => {
		try {
			dispatch({ type: 'TABLE_DELETE_REQUEST' });
			await axios.delete(`/weddings/${weddingId}/tables/${tableId}`);

			dispatch({ type: 'TABLE_DELETE_SUCCESS' });
		} catch (error: any) {
			dispatch({
				type: 'TABLE_DELETE_FAIL',
				payload: error.response.data.message,
			});
		}
	};

export type FILE_UPLOAD_REQUEST = {
	type: 'FILE_UPLOAD_REQUEST';
};

export type FILE_UPLOAD_SUCCESS = {
	type: 'FILE_UPLOAD_SUCCESS';
	payload: {
		message: string;
		tablesCreated: number;
		guestsCreated: number;
	};
};

export type FILE_UPLOAD_FAIL = {
	type: 'FILE_UPLOAD_FAIL';
	payload: string;
};

export type FILE_UPLOAD_RESET = {
	type: 'FILE_UPLOAD_RESET';
};

export const uploadTablesFile =
	(weddingId: number, file: File) => async (dispatch: AppDispatch) => {
		try {
			dispatch({ type: 'FILE_UPLOAD_REQUEST' });
			
			const formData = new FormData();
			formData.append('file', file);

			const { data } = await axios.post(
				`/weddings/${weddingId}/upload-tables`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				}
			);

			dispatch({
				type: 'FILE_UPLOAD_SUCCESS',
				payload: {
					message: data.message,
					tablesCreated: data.tablesCreated,
					guestsCreated: data.guestsCreated,
				},
			});
		} catch (error: any) {
			dispatch({
				type: 'FILE_UPLOAD_FAIL',
				payload: error.response?.data?.message || 'שגיאה בהעלאת הקובץ',
			});
		}
	};
